export default __webpack_public_path__ + "static/media/tour-access-lock.4841efc5.svg";